import { Box, Button, Stack, Typography } from '@mui/material';
import { CheckCircleRounded, LoginRounded } from '@mui/icons-material';
import { GlassPanel } from '@charlava-com/ui-react-mui/components';
import { useUser } from '@charlava-com/auth';

export function Logout() {
  const [, userActions] = useUser();

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      sx={{ minHeight: '60vh', px: 2 }}
    >
      <GlassPanel sx={{ maxWidth: 480, width: '100%', textAlign: 'center' }}>
        <Stack spacing={2.5} alignItems="center">
          <Box
            sx={{
              width: 64,
              height: 64,
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background:
                'linear-gradient(135deg, rgba(86,189,255,0.18), rgba(139,92,246,0.18))',
              border: '1px solid rgba(86,189,255,0.4)',
            }}
          >
            <CheckCircleRounded sx={{ fontSize: 36, color: '#56bdff' }} />
          </Box>

          <Stack spacing={0.5}>
            <Typography variant="h5" fontWeight={700}>
              You&rsquo;ve been signed out
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Thanks for practicing today &mdash; see you next session.
            </Typography>
          </Stack>

          <Button
            variant="contained"
            color="primary"
            fullWidth
            startIcon={<LoginRounded />}
            onClick={() => userActions.signIn()}
            sx={{ mt: 1 }}
          >
            Sign back in
          </Button>
        </Stack>
      </GlassPanel>
    </Stack>
  );
}

export default Logout;
